"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Map = void 0;

var _react = _interopRequireDefault(require("react"));

var _googleMapReact = _interopRequireDefault(require("google-map-react"));

var _Marker = require("./Marker");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  center: {
    lat: 43.0594562,
    lng: 141.3193102
  },
  zoom: 16
};

var Map = function Map(_ref) {
  var _ref$center = _ref.center,
      center = _ref$center === void 0 ? defaultProps.center : _ref$center,
      _ref$zoom = _ref.zoom,
      zoom = _ref$zoom === void 0 ? defaultProps.zoom : _ref$zoom;

  var mapStyles = require("./style.json");

  return /*#__PURE__*/_react["default"].createElement(_googleMapReact["default"], {
    bootstrapURLKeys: {
      key: "AIzaSyAgzcreDhj8Qbs45_vOqad1CUIbd8B0td0"
    },
    defaultCenter: center,
    defaultZoom: zoom,
    options: {
      styles: mapStyles,
      disableDefaultUI: false,
      navigationControl: false,
      mapTypeControl: false,
      scaleControl: false,
      draggable: false
    }
  }, /*#__PURE__*/_react["default"].createElement(_Marker.Marker, {
    lat: 43.0594562,
    lng: 141.3193102,
    text: "\u3055\u308F\u3060\u6574\u9AA8\u9662"
  }));
};

exports.Map = Map;